import { styled } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CustomItem } from '../../../models/quotations/Quotation';
import { QuotationCustomItem } from '../quotation-custom-items/QuotationCustomItem';

const AddNewLine = styled('a')(() => ({
    cursor: 'pointer',
}));

const StyledDiv = styled('div')(() => ({
    paddingBottom: '10px',
}));

export const CustomItemsWrapper: React.FC<{
    handleChange: (items: CustomItem[]) => void;
    defaultCustomItems: CustomItem[];
    fieldsVariant: 'filled' | 'outlined';
    origin?: 'products' | 'custom-items';
}> = (props) => {
    const {
        handleChange,
        defaultCustomItems,
        fieldsVariant,
        origin = 'custom-items',
    } = props;
    const { t } = useTranslation('quotations', {
        keyPrefix: 'QUOTATIONS.QUOTATION_EDITOR.CUSTOM_ITEMS',
    });

    const [customItems, setCustomItems] = useState<CustomItem[]>(
        defaultCustomItems
            ? defaultCustomItems.map((item): CustomItem => {
                  return {
                      name: item.name,
                      net_price: item.net_price,
                      quantity: item.quantity,
                      unit: item.unit,
                      tax: item.tax,
                      gross_price: item.gross_price,
                  };
              })
            : []
    );

    useEffect(() => {
        if (defaultCustomItems) {
            setCustomItems(
                defaultCustomItems.map((item): CustomItem => {
                    return {
                        name: item.name,
                        net_price: item.net_price,
                        quantity: item.quantity,
                        unit: item.unit,
                        tax: item.tax,
                        gross_price: item.gross_price,
                    };
                })
            );
        }
    }, [defaultCustomItems]);

    const handleSave = (data: CustomItem[]) => {
        setCustomItems(data);
        handleChange(data);
    };

    const updateItem = (index, content) => {
        const newArray = [...customItems];
        newArray[index] = content;
        handleSave(newArray);
    };

    const addNew = () => {
        handleSave([
            ...customItems,
            {
                name: '',
                net_price: 1,
                quantity: 1,
                unit: 'db',
                tax: 27,
                gross_price: 1,
            },
        ]);
    };

    const deleteItem = (index: number) => {
        const newArray = [...customItems];
        newArray.splice(index, 1);
        handleSave([...newArray]);
    };

    return (
        <div>
            <div>
                {customItems.length > 0 &&
                    customItems.map((item, index) => (
                        <QuotationCustomItem
                            item={item}
                            key={index}
                            index={index}
                            fieldsVariant={fieldsVariant}
                            changeFieldsHandle={updateItem}
                            deleteItemHandle={deleteItem}
                        />
                    ))}
            </div>
            <StyledDiv>
                <AddNewLine onClick={addNew}>
                    +{' '}
                    {t(origin === 'custom-items' ? 'ADD_NEW' : 'ADD_NEW_NORMA')}
                </AddNewLine>
            </StyledDiv>
        </div>
    );
};
